import {useState, useEffect} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import TableWrapRows from '../StockItems/TableWrapRows';
import * as SharedAcross from '../utilities/SharedAcross';
import * as FormulaFunctions from '../utilities/FormulaFunctions';

function App(props) {

  var programSetID = props.programSetID;
  var userID = props.userID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var setSelectedStep = props.setSelectedStep;

  const [isSubmitted, setIsSubmitted] = useState(-1);


  var failFunction = function(){
    setIsSubmitted(-1);
    console.log("Fail");
  }

  const [previousCodes, setPreviousCodes] = useState([]);

  function getPreviousCodes(){
    var postFunction1 = function(responseIn){
      setPreviousCodes(responseIn.v);
    }

    if (signKey){
      var passObject = {
          u:'getPreviousCodes',
          sessionID,
          userID,
          signKey,
          programSetID,
        };

      ServerComms.fetchSomething(passObject, postFunction1, failFunction, []);
      
    }
  }

  function getOldCode(codeID){

    var postFunction = function(responseIn){
      console.log(responseIn);
      if (responseIn.t === 'atom'){
        window.alert('Insufficient credits');
      }else{
        setSelectedStep(['de', 'coded', responseIn.v]);
      }
      setIsSubmitted(-1);
    }

    return function(e){
      var passObject = {
          u:"getOldCode",
          sessionID,
          signKey,
          programSetID,
          codeID,
          userID,
        };
      setIsSubmitted(codeID);
      ServerComms.fetchSomething(passObject, postFunction, failFunction, []);
    }

  }


  useEffect(()=>{
    getPreviousCodes();
  }, []);  // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    getPreviousCodes();
  }, [userID]);  // eslint-disable-line react-hooks/exhaustive-deps


  if (previousCodes.length > 0){
    var nosPrev = previousCodes.length;
    if (nosPrev > 2){
      nosPrev = 2;
    }
    var colWidthPrev = (100 / nosPrev) + '%';
    var previousGrid = SharedAcross.convertToGrid(previousCodes, nosPrev, true);
    var previousRows = previousGrid.map((aRow, index)=>{
      var cells = aRow.map((aCell, index2)=>{
        if (aCell){
          var codeID = aCell.v[0].v;
          var dateString = FormulaFunctions.getDateFromSql(aCell.v[1]);
          if (isSubmitted === codeID){
            dateString = 'Loading...'
          }
          return <td key={index2} className='sCellLight' style={{width:colWidthPrev}} onClick={getOldCode(codeID)}>{dateString}</td>
//
        }else{
          return <td key={index2} style={{width:colWidthPrev}}></td>
        }
      })
      return <tr key={index}>{cells}</tr>
    })
    return <div className="tab-content"><div className="row mb-4">
      <div className="col-lg-10 mx-auto text-center">
        <p className="lead mb-0"><b>Previous Code</b></p> 
        <TableWrapRows rows={previousRows}/>
        </div></div></div>
  }else{
    return null;
  }

}

export default App;
